// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3ea899b3","453":"ffd56d18"}[chunkId] + ".chunk.js";
};